import { t } from "i18next";

export interface FormData {
  [key: string]: string;
}

export interface FormErrors {
  [key: string]: string;
}

export function requiredField(formData: any, errors: any, name: string, isValid: boolean = true): boolean {
    if (!formData[name].trim()) {
        errors[name] = t('error.required', { field: name });
        return false;
    } else {
        return isValid;
    }
}

export function removeError(isValid: boolean, errors: any, name: string): any {
    if (isValid) {
        delete errors[name];
    }
    return errors;
}

export const validateEmail = (
  email: string,
  errors: FormErrors
): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    errors.email = 'Indirizzo email non valido';
    return false;
  }
  errors.email = '';
  return true;
};

export const validatePasswordMatch = (
  password: string,
  confirmPassword: string,
  errors: FormErrors
): boolean => {
  if (password !== confirmPassword) {
    errors.confirmPassword = 'Le password non corrispondono';
    return false;
  }
  errors.confirmPassword = '';
  return true;
};

export const validatePasswordStrength = (
  password: string,
  errors: FormErrors
): boolean => {
  // Minimo 8 caratteri, almeno una maiuscola, una minuscola, un numero e un simbolo
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  if (!regex.test(password)) {
    errors.password =
      t('error.weak_password');
    return false;
  }
  errors.password = '';
  return true;
};

export const validatePhone = (phone: string, errors: any, field: string): boolean => {
  let isValid = true;

  // Rimuove spazi, trattini o parentesi
  const cleanedPhone = phone.replace(/[\s\-()]/g, '');

  // Accetta numeri con eventuale prefisso + (es. +39, +1)
  const phoneRegex = /^\+?[0-9]{10,15}$/;

  if (!phoneRegex.test(cleanedPhone)) {
    errors[field] = t('error.invalid_phone');
    isValid = false;
  } else {
    errors[field] = "";
  }

  return isValid;
};


export const validateDate = (date: string, errors: any, field: string): boolean => {
  let isValid = true;

  const inputDate = new Date(date);
  const today = new Date();

  const adult = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
  );

  if (inputDate > adult) {
    errors[field] = t('error.adult');
    isValid = false;
  }

  if (isValid) {
    delete errors[field];
  }

  return isValid;
};
